import { FLOW } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(FLOW);
const actions = { ...rawActions, ...thunkFactory(FLOW, '/flows/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(FLOW, initialState);

// SAGAS
const sagas = sagasFactory(FLOW, '/flows/', { scopedByAccount: true });
export { sagas };

